import React, { FunctionComponent, useEffect, useState } from 'react';

import { Text } from 'components/chroma';
import { Modal } from 'components';
import { YesNoButtonGroup } from 'components/YesNoButtonGroup';
import { MotorFunnelState } from 'scenes/motor/types';
import { ApiName } from 'scenes/common/api/quote';
import styled from 'styled-components';
import { hasRecoverableBusinessError } from 'scenes/common/helpers/apiData';

const TextWrapper = styled.div`
  text-align: center;
  margin-bottom: 1em;
`;

const content = (
  <TextWrapper>
    <Text>
      <strong>Third Party Property Damage</strong>&nbsp; or &nbsp;
      <strong>Third Party Fire and Theft</strong>&nbsp;are not available due to
      the current value of your car.
    </Text>
    <Text>
      Would you instead like to continue with a&nbsp;
      <strong>Coles Comprehensive Car Insurance</strong>&nbsp;quote?
    </Text>
  </TextWrapper>
);

export type RecoverableQuoteErrorModalProps = {
  onDeclineAction: Function;
  onCreateQuote: Function;
  funnelState: MotorFunnelState;
  onRecoveryActions: {
    [key: string]: {
      recoveryFn: Function;
    };
  };
};

export const RecoverableQuoteErrorModal: FunctionComponent<RecoverableQuoteErrorModalProps> = ({
  onDeclineAction,
  onRecoveryActions,
  onCreateQuote,
  funnelState,
}) => {
  const [acceptedFix, setAcceptedFix] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(
    hasRecoverableBusinessError(funnelState.apiResponses.quoteDetails)
  );
  useEffect(() => {
    if (isOpen && acceptedFix) {
      // Retry failing API. Can be extended to cover failure scenarios
      // for other API calls.
      if (
        funnelState.apiResponses.quoteDetails.errorReason?.stage ===
        ApiName.CreateQuote
      ) {
        onCreateQuote();
      }
    }
  }, [
    funnelState.quoteDetails.preselectedCoverType,
    funnelState.quoteDetails.preselectedInsuranceType,
    isOpen,
    acceptedFix,
    onCreateQuote,
    funnelState.apiResponses.quoteDetails.errorReason,
  ]);

  // If there's no defined recovery function, the user will be declined
  const recoveryAction = () => {
    const key = funnelState.apiResponses.quoteDetails.errorReason?.type;
    if (key && onRecoveryActions[key]) {
      return onRecoveryActions[key].recoveryFn();
    }
    return onDeclineAction();
  };

  return (
    <Modal isOpen={isOpen} answerRequired onClose={() => setIsOpen(false)}>
      {content}
      <YesNoButtonGroup
        onNo={onDeclineAction}
        // Create new quote on Yes
        onYes={() => {
          setAcceptedFix(true);
          recoveryAction();
        }}
      />
    </Modal>
  );
};

export default RecoverableQuoteErrorModal;
